"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetApiCaches = exports.apiMiddleware = exports.apiReducers = void 0;
var analytics_1 = require("./analytics");
var baskets_1 = require("./baskets");
var client_1 = require("./client");
var customer_analytics_1 = require("./customer_analytics");
var customers_1 = require("./customers");
var letsachieve_1 = require("./letsachieve");
var loyalty_1 = require("./loyalty");
var orders_1 = require("./orders");
var payments_1 = require("./payments");
var products_1 = require("./products");
var subscriptions_1 = require("./subscriptions");
// computed keys keep each reducerPath as a literal type, which Object.fromEntries would erase and break RootState
var apiReducers = (_a = {},
    _a[analytics_1.analyticsApi.reducerPath] = analytics_1.analyticsApi.reducer,
    _a[baskets_1.basketsApi.reducerPath] = baskets_1.basketsApi.reducer,
    _a[client_1.clientApi.reducerPath] = client_1.clientApi.reducer,
    _a[customer_analytics_1.customerAnalyticsApi.reducerPath] = customer_analytics_1.customerAnalyticsApi.reducer,
    _a[customers_1.customersApi.reducerPath] = customers_1.customersApi.reducer,
    _a[letsachieve_1.letsachieveApi.reducerPath] = letsachieve_1.letsachieveApi.reducer,
    _a[loyalty_1.loyaltyApi.reducerPath] = loyalty_1.loyaltyApi.reducer,
    _a[orders_1.ordersApi.reducerPath] = orders_1.ordersApi.reducer,
    _a[payments_1.paymentsApi.reducerPath] = payments_1.paymentsApi.reducer,
    _a[products_1.productsApi.reducerPath] = products_1.productsApi.reducer,
    _a[subscriptions_1.subscriptionsApi.reducerPath] = subscriptions_1.subscriptionsApi.reducer,
    _a);
exports.apiReducers = apiReducers;
var apiMiddleware = [
    analytics_1.analyticsApi.middleware,
    baskets_1.basketsApi.middleware,
    client_1.clientApi.middleware,
    customer_analytics_1.customerAnalyticsApi.middleware,
    customers_1.customersApi.middleware,
    letsachieve_1.letsachieveApi.middleware,
    loyalty_1.loyaltyApi.middleware,
    orders_1.ordersApi.middleware,
    payments_1.paymentsApi.middleware,
    products_1.productsApi.middleware,
    subscriptions_1.subscriptionsApi.middleware,
];
exports.apiMiddleware = apiMiddleware;
// cache keys carry no session, so anything cached under the previous account would otherwise be served to the next one
var resetApiCaches = function (dispatch) {
    dispatch(analytics_1.analyticsApi.util.resetApiState());
    dispatch(baskets_1.basketsApi.util.resetApiState());
    dispatch(client_1.clientApi.util.resetApiState());
    dispatch(customer_analytics_1.customerAnalyticsApi.util.resetApiState());
    dispatch(customers_1.customersApi.util.resetApiState());
    dispatch(letsachieve_1.letsachieveApi.util.resetApiState());
    dispatch(loyalty_1.loyaltyApi.util.resetApiState());
    dispatch(orders_1.ordersApi.util.resetApiState());
    dispatch(payments_1.paymentsApi.util.resetApiState());
    dispatch(products_1.productsApi.util.resetApiState());
    dispatch(subscriptions_1.subscriptionsApi.util.resetApiState());
};
exports.resetApiCaches = resetApiCaches;
